import { defineComponent as k, ref as u, computed as a, resolveComponent as c, openBlock as v, createElementBlock as h, mergeProps as s, toHandlers as g, createVNode as m, normalizeProps as b, guardReactiveProps as O, createSlots as I, withCtx as S, renderSlot as P } from "vue";
import { i as $ } from "./constants-ByXK9fg4.mjs";
import { O as z, a as B, I as y } from "./OrIcon-k8cyvh-D.mjs";
import { O as R } from "./OrTooltip-DqwjoE82.mjs";
import { _ as C } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var t = /* @__PURE__ */ ((e) => (e.Default = "default", e.Primary = "primary", e.Danger = "danger", e.Inherit = "inherit", e))(t || {});
const D = [
  // Layout
  "layout-inline-row justify-center",
  // Shape
  "rounded-full",
  // Interactivity
  "interactivity-click",
  // Typography
  "typography-button",
  // Iconography
  "iconography-outlined",
  // Iconography (hover)
  "hover:md:iconography-filled",
  // Iconography (focus)
  "focus-visible:md:iconography-filled",
  // Iconography (active)
  "active:iconography-filled",
  // Theme
  "!outline outline-2 outline-transparent"
], V = {
  [t.Default]: [
    // Theme
    "theme-preset-3-primary",
    "dark:theme-preset-3-primary-dark",
    "theme-foreground-outline",
    "dark:theme-foreground-outline-dark",
    // Theme (hover)
    "hover:md:theme-foreground-default",
    "dark:hover:md:theme-foreground-default-dark",
    "hover:md:outline-primary-opacity-0-08",
    "dark:hover:md:outline-primary-opacity-0-08-dark",
    // Theme (focus)
    "focus-visible:md:theme-foreground-default",
    "dark:focus-visible:md:theme-foreground-default-dark",
    "focus-visible:md:outline-primary-opacity-0-08",
    "dark:focus-visible:md:outline-primary-opacity-0-08-dark",
    // Theme (active)
    "active:theme-foreground-default",
    "dark:active:theme-foreground-default-dark",
    "active:outline-primary-opacity-0-08",
    "dark:active:outline-primary-opacity-0-08-dark",
    "active:md:outline-primary-opacity-0-16",
    "dark:active:md:outline-primary-opacity-0-16-dark",
    // Theme (selected)
    "selected:theme-foreground-default",
    "dark:selected:theme-foreground-default-dark"
  ],
  [t.Primary]: [
    // Theme
    "theme-preset-3-primary",
    "dark:theme-preset-3-primary-dark",
    // Theme (hover)
    "hover:md:outline-primary-opacity-0-08",
    "dark:hover:md:outline-primary-opacity-0-08-dark",
    // Theme (focus)
    "focus-visible:md:outline-primary-opacity-0-08",
    "dark:focus-visible:md:outline-primary-opacity-0-08-dark",
    // Theme (active)
    "active:outline-primary-opacity-0-08",
    "dark:active:outline-primary-opacity-0-08-dark",
    "active:md:outline-primary-opacity-0-16",
    "dark:active:md:outline-primary-opacity-0-16-dark"
  ],
  [t.Danger]: [
    // Theme
    "theme-preset-3-error",
    "dark:theme-preset-3-error-dark",
    // Theme (hover)
    "hover:md:outline-error-opacity-0-08",
    "dark:hover:md:outline-error-opacity-0-08-dark",
    // Theme (focus)
    "focus-visible:md:outline-error-opacity-0-08",
    "dark:focus-visible:md:outline-error-opacity-0-08-dark",
    // Theme (active)
    "active:outline-error-opacity-0-08",
    "dark:active:outline-error-opacity-0-08-dark",
    "active:md:outline-error-opacity-0-16",
    "dark:active:md:outline-error-opacity-0-16-dark"
  ],
  [t.Inherit]: [
    // Theme
    "theme-preset-3-primary",
    "dark:theme-preset-3-primary-dark",
    "theme-foreground-inherit",
    "dark:theme-foreground-inherit-dark",
    // Theme (hover)
    "hover:md:outline-primary-opacity-0-08",
    "dark:hover:md:outline-primary-opacity-0-08-dark",
    // Theme (focus)
    "focus-visible:md:outline-primary-opacity-0-08",
    "dark:focus-visible:md:outline-primary-opacity-0-08-dark",
    // Theme (active)
    "active:outline-primary-opacity-0-08",
    "dark:active:outline-primary-opacity-0-08-dark",
    "active:md:outline-primary-opacity-0-16",
    "dark:active:md:outline-primary-opacity-0-16-dark"
  ]
}, j = k({
  name: "OrIconButton",
  components: {
    OrIcon: z,
    OrTooltip: R
  },
  props: {
    // TODO: Remove after migration to Vue 3
    additionalStyles: {
      type: Array,
      default: () => []
    },
    icon: {
      type: [String, Object],
      required: !0
    },
    color: {
      type: String,
      default: () => t.Default
    },
    size: {
      type: String,
      default: () => B.M
    },
    selected: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: [String, Object],
      default: void 0
    }
  },
  emits: [
    "click",
    "focus",
    "blur"
  ],
  expose: [
    "root"
  ],
  setup(e, { emit: r }) {
    const n = u(), d = u(), l = a(() => typeof e.icon == "string" ? {
      icon: e.icon,
      variant: y.Inherit,
      size: e.size
    } : {
      variant: y.Inherit,
      size: e.size,
      ...e.icon
    }), p = a(() => typeof e.tooltip == "string" ? {
      content: e.tooltip
    } : e.tooltip), i = a(() => [
      "or-icon-button-v3",
      ...D,
      ...V[e.color],
      ...e.additionalStyles
    ]);
    return {
      root: n,
      tooltipRef: d,
      rootStyles: i,
      iconProps: l,
      tooltipProps: p,
      isVue3: $,
      onClick: (o) => r("click", o),
      onFocus: (o) => r("focus", o),
      onBlur: (o) => r("blur", o)
    };
  }
}), M = ["selected", "disabled"];
function T(e, r, n, d, l, p) {
  const i = c("OrIcon"), o = c("OrTooltip");
  return v(), h("button", s({
    ref: "root",
    class: e.rootStyles,
    type: "button",
    selected: e.selected,
    disabled: e.disabled,
    onMouseover: r[0] || (r[0] = (f) => e.tooltipRef && e.tooltipRef.open()),
    onMouseout: r[1] || (r[1] = (f) => e.tooltipRef && e.tooltipRef.close())
  }, g({
    ...e.isVue3 ? {} : e.$listeners,
    click: e.onClick,
    focus: e.onFocus,
    blur: e.onBlur
  }, !0)), [
    m(i, b(O(e.iconProps)), null, 16),
    m(o, s({
      ref: "tooltipRef",
      trigger: e.root
    }, e.tooltipProps), I({ _: 2 }, [
      e.$slots.tooltipContent ? {
        name: "content",
        fn: S(() => [
          P(e.$slots, "tooltipContent")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["trigger"])
  ], 16, M);
}
const H = /* @__PURE__ */ C(j, [["render", T]]);
export {
  t as I,
  H as O
};
//# sourceMappingURL=OrIconButton-BlHCLpeW.mjs.map
